export const USER = {
    SIGN_UP: () => "/1/signup",
};
